import { faChevronLeft, faArrowLeftToLine } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode } from "react";
import classNames from "classnames";
import type { IBuilderToolbarMenuViewSection } from "./types";
import "./builderToolbarMenuView.scss";

export type TBuilderToolbarMenuViewPresentation = "desktop-panel" | "mobile-sheet-body";

interface IBuilderToolbarMenuViewProps {
  title: string;
  presentation?: TBuilderToolbarMenuViewPresentation;
  noSectionsPadding?: boolean;
  goBackToParentView?: () => void;
  onClose?: () => void;
  closeAriaLabel?: string;
  sections: IBuilderToolbarMenuViewSection[];
  footer?: ReactNode;
  sectionsContainerRef?: React.Ref<HTMLDivElement>;
}

export function BuilderToolbarMenuView(props: IBuilderToolbarMenuViewProps) {
  const {
    title,
    presentation = "desktop-panel",
    noSectionsPadding,
    goBackToParentView,
    onClose,
    closeAriaLabel,
    sections,
    footer,
    sectionsContainerRef,
  } = props;

  const isMobileSheetBody = presentation === "mobile-sheet-body";

  return (
    <div
      className={classNames("builder-toolbar-menu-view", {
        "builder-toolbar-menu-view--with-footer": footer != null,
        "builder-toolbar-menu-view--mobile-sheet-body": isMobileSheetBody,
      })}
    >
      {!isMobileSheetBody ? (
        <div className="builder-toolbar-menu-view-header">
          <div className="builder-toolbar-menu-view-header-heading-container">
            {goBackToParentView && (
              <button
                type="button"
                className="builder-toolbar-menu-view-header-chevron-button"
                aria-label={title}
                onClick={goBackToParentView}
              >
                <FontAwesomeIcon
                  className="builder-toolbar-menu-view-header-chevron-icon"
                  icon={faChevronLeft}
                  aria-hidden="true"
                />
              </button>
            )}
            <h3>{title}</h3>
          </div>
          <button
            type="button"
            className="builder-toolbar-menu-view-header-close-button"
            aria-label={closeAriaLabel ?? title}
            onClick={onClose}
          >
            <FontAwesomeIcon
              icon={faArrowLeftToLine}
              className="builder-toolbar-menu-view-header-arrow-left-icon"
              aria-hidden="true"
            />
          </button>
        </div>
      ) : null}
      <div
        ref={sectionsContainerRef}
        className={classNames("builder-toolbar-menu-view-sections", {
          "builder-toolbar-menu-view-sections-no-padding": noSectionsPadding,
        })}
      >
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            <div
              className={classNames("builder-toolbar-menu-view-section", {
                "builder-toolbar-menu-view-section--grow": section.grow === true,
              })}
            >
              {section.title && (
                <div className="builder-toolbar-menu-view-section-title">{section.title}</div>
              )}
              <div className="builder-toolbar-menu-view-section-content">{section.content}</div>
            </div>
            {index < sections.length - 1 && (
              <hr className="builder-toolbar-menu-view-section-divider" />
            )}
          </React.Fragment>
        ))}
      </div>
      {footer != null ? <div className="builder-toolbar-menu-view-footer">{footer}</div> : null}
    </div>
  );
}
